<p-tabView [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
    <p-tabPanel header="{{ 'Configuration.User.Users' | transloco }}">
        <p-table #userlist [value]="allUsersList"
             [paginator]="true" [rows]="15" [globalFilterFields]="['name', 'emailId', 'role' ]"  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore">
            <ng-template pTemplate="caption">
                <div class="p-d-flex">
                    <p-toggleButton onLabel="Active" offLabel="InActive" [onIcon]="'pi pi-check'"
                        [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isActive"  (onChange)="filterUsers()"></p-toggleButton>
                    <span class="p-input-icon-left p-ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="
                                userlist.filterGlobal(
                                    $event.target.value,
                                    'contains'
                                )
                            " placeholder="{{
                                'Configuration.User.Search_keyword' | transloco
                            }}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ "Configuration.User.Name" | transloco }}</th>
                    <th>{{ "Configuration.User.Role" | transloco }}</th>
                    <th>
                        {{ "Configuration.User.Email_Addrress" | transloco }}
                    </th>
                    <th>{{ "Configuration.User.Phone" | transloco }}</th>
                    <th>{{ "Configuration.User.Location" | transloco }}</th>
                    <th>{{ "Configuration.User.Action" | transloco }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex">
                <tr>
                    <td class="user-display">
                        <img [alt]="'user image'" [src]="user?.profileImageUrl ? user.profileImageUrl : defaultProfileImage" />
                        <span class="wordBreak p-ml-1">{{ user.name }}</span>
                    </td>
                    <!-- <td class="wordBreak">{{ user.name }}</td> -->
                    <td>
                        {{
                        user.role
                        ? user.role
                        : "NA"
                        }}
                    </td>
                    <td class="wordBreak">{{ user.emailId }}</td>
                    <td>
                        {{
                        user.userPhone
                        ? user.userPhone
                        : "NA"
                        }}
                    </td>
                    <td>
                        {{
                        user.city
                        ? user.city
                        : "NA"
                        }}
                    </td>
                    <td class="action">
                        <span *ngIf="getUserCustomPermission('Edit')" class="btnBars p-mr-0"
                            (click)="loadMandatoryData('edit',user)" pTooltip="Edit" tooltipPosition="top"><i
                                class="pi pi-pencil"></i>
                        </span>
                        <span class="btnBars p-mr-0" (click)="deleteUser(i, user)" *ngIf="
                                app.user.userId != user.id &&
                                getUserCustomPermission('Delete')
                            " pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                        <span *ngIf="getUserCustomPermission('Read')" class="btnBars p-mr-0"
                            (click)="loadMandatoryData('view',user)" pTooltip="View" tooltipPosition="top"><i
                                class="pi pi-eye"></i></span>
                        <span class="btnBars p-mr-0" (click)="loadMandatoryData('copy',user)" pTooltip="Copy"
                            tooltipPosition="top"><i class="pi pi-clone"></i></span>
                        <!-- <span class="btnBars p-mr-0" (click)="setUserPermissions(user)" pTooltip="Permission"
                tooltipPosition="top"><i class="pi pi-lock"></i></span> -->
                        <span class="btnBars p-mr-0" (click)="openOrgChart(user)" pTooltip="Organization"
                            tooltipPosition="top"><i class="pi pi-sitemap"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>

    <p-tabPanel header="{{ 'Configuration.User.Groups' | transloco }}">
        <p-table [value]="allUserGroup" [paginator]="true" [rows]="15" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"  [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ "Configuration.User.Group_Name" | transloco }}</th>
                    <th>{{ "Configuration.User.Group_Owner" | transloco }}</th>
                    <th>{{ "Configuration.User.Last_Updated" | transloco }}</th>
                    <th>{{ "Configuration.User.Is_Active" | transloco }}</th>
                    <th>{{ "Configuration.User.Action" | transloco }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-userGroup let-i="rowIndex">
                <tr>
                    <td>{{ userGroup.group.name }}</td>
                    <td>{{ userGroup.ownerList }}</td>
                    <td>
                        {{
                        userGroup.group.updatedDate != null
                        ? (userGroup.group.updatedDate
                        | date : "MM/dd/yyyy")
                        : "NA"
                        }}
                    </td>
                    <td>{{ userGroup.statusId == 1 ? "Yes" : "No" }}</td>
                    <td class="action">
                        <span class="btnBars p-mr-0" (click)="showAddEditUserGroup(userGroup, 'view')" pTooltip="View"
                            tooltipPosition="top"><i class="pi pi-eye"></i></span>
                        <span class="btnBars p-mr-0" (click)="showAddEditUserGroup(userGroup, 'edit')" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                        <span class="btnBars p-mr-0" (click)="showAddEditUserGroup(userGroup, 'copy')" pTooltip="Copy"
                            tooltipPosition="top"><i class="pi pi-clone"></i></span>
                        <span class="btnBars p-mr-0" (click)="deleteUserGroup(userGroup.groupId, i)" *ngIf="i > 0"
                            pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>

    <p-tabPanel header="{{ 'Configuration.User.Template' | transloco }}">
        <p-table [value]="allUserTemplates">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ "Configuration.User.Name" | transloco }}</th>
                    <th>{{ "Configuration.User.Created_By" | transloco }}</th>
                    <th>
                        {{ "Configuration.User.Last_Modified" | transloco }}
                    </th>
                    <th>{{ "Configuration.User.Is_Active" | transloco }}</th>
                    <th>{{ "Configuration.User.Action" | transloco }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template let-i="rowIndex">
                <tr>
                    <td>{{ template.templateName }}</td>
                    <td>Default</td>
                    <td>{{ template.updatedDate | date : "MM/dd/yyyy" }}</td>
                    <td>{{ template.isActive }}</td>
                    <td class="action">
                        <span class="btnBars p-mr-0" (click)="showEditUserTemplate(template)" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                        <!-- <span class="btnBars p-mr-0" (click)="showSwapUserLabels(template)" pTooltip="Template"
                tooltipPosition="top"><i class="pi pi-id-card"></i></span> -->
                        <span class="btnBars p-mr-0" *ngIf="i > 0" (click)="deleteAccountTemplate(i)" pTooltip="Delete"
                            tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>

    <p-tabPanel header="{{ 'Configuration.User.Fields' | transloco }}">
        <p-accordion [(activeIndex)]="activeAccordionIndex" (onOpen)="onOpenAccordion($event)">
            <p-accordionTab header="{{ 'Configuration.User.Annual_Income' | transloco }}">
                <p-table [value]="incomes" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-10">
                                {{ "Configuration.User.Name" | transloco }}
                            </th>
                            <th class="p-col-2">
                                {{ "Configuration.User.Action" | transloco }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr [pReorderableRow]="index">
                            <td class="p-col-10">{{ data.name }}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" (click)="
                                        showEditContactData(
                                            data,
                                            contactDataTypes[0]
                                        )
                                    " pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                <span class="btnBars p-mr-0" (click)="delAnnualIncome(data)" pTooltip="Delete"
                                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <p-accordionTab header="{{ 'Configuration.User.Degree' | transloco }}">
                <p-table [value]="degrees" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-10">
                                {{ "Configuration.User.Name" | transloco }}
                            </th>
                            <th class="p-col-2">
                                {{ "Configuration.User.Action" | transloco }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr [pReorderableRow]="index">
                            <td class="p-col-10">{{ data.name }}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" (click)="
                                        showEditContactData(
                                            data,
                                            contactDataTypes[2]
                                        )
                                    " pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                <span class="btnBars p-mr-0" (click)="delDegree(data)" pTooltip="Delete"
                                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <p-accordionTab header="{{ 'Configuration.User.Field_Of_Study' | transloco }}">
                <p-table [value]="studyFields" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-10">
                                {{ "Configuration.User.Name" | transloco }}
                            </th>
                            <th class="p-col-2">
                                {{ "Configuration.User.Action" | transloco }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr [pReorderableRow]="index">
                            <td class="p-col-10">{{ data.name }}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" (click)="
                                        showEditContactData(
                                            data,
                                            contactDataTypes[4]
                                        )
                                    " pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                <span class="btnBars p-mr-0" (click)="delStudyField(data)" pTooltip="Delete"
                                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <p-accordionTab header="{{ 'Configuration.User.Gender' | transloco }}">
                <p-table [value]="genders" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-10">
                                {{ "Configuration.User.Name" | transloco }}
                            </th>
                            <th class="p-col-2">
                                {{ "Configuration.User.Action" | transloco }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr>
                            <td class="p-col-10">{{ data.name }}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" (click)="
                                        showEditContactData(
                                            data,
                                            contactDataTypes[5]
                                        )
                                    " pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                <span class="btnBars p-mr-0" (click)="delGender(data)" pTooltip="Delete"
                                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <p-accordionTab header="{{ 'Configuration.User.Language_Spoken' | transloco }}">
                <p-table [value]="languages" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-10">
                                {{ "Configuration.User.Name" | transloco }}
                            </th>
                            <th class="p-col-2">
                                {{ "Configuration.User.Action" | transloco }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr>
                            <td class="p-col-10">{{ data.name }}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" (click)="
                                        showEditContactData(
                                            data,
                                            contactDataTypes[6]
                                        )
                                    " pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                <span class="btnBars p-mr-0" (click)="delLanguage(data)" pTooltip="Delete"
                                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <p-accordionTab header="{{ 'Configuration.User.Marital_Status' | transloco }}">
                <p-table [value]="maritals" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-10">
                                {{ "Configuration.User.Name" | transloco }}
                            </th>
                            <th class="p-col-2">
                                {{ "Configuration.User.Action" | transloco }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr [pReorderableRow]="index">
                            <td class="p-col-10">{{ data.name }}</td>
                            <td class="p-col-2 action">
                                <span class="btnBars p-mr-0" (click)="
                                        showEditContactData(
                                            data,
                                            contactDataTypes[7]
                                        )
                                    " pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                <span class="btnBars p-mr-0" (click)="delMaritalStatus(data)" pTooltip="Delete"
                                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <p-accordionTab header="Job Type">
                <p-table [value]="jobTypes" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-8">
                                {{ "Configuration.User.Name" | transloco }}
                            </th>
                            <th class="p-col-2">Associated User</th>
                            <th class="p-col-2">
                                {{ "Configuration.User.Action" | transloco }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr [pReorderableRow]="index">
                            <td class="p-col-8">{{ data.name }}</td>
                            <td class="p-col-2 click-enable" (click)="getNoOfAssociatedUsers(data?.id)">
                                {{ data?.noOfAssociatedUsers }}
                            </td>
                            <td class="p-col-2 action">
                                <ng-container *ngIf="data?.sysGenerated">
                                    <span style="color: #b3b3b3">System Generated</span>
                                </ng-container>
                                <ng-container *ngIf="!data?.sysGenerated">
                                    <span class="btnBars p-mr-0" (click)="
                                            showEditContactData(
                                                data,
                                                contactDataTypes[14]
                                            )
                                        " pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                    <span class="btnBars p-mr-0" (click)="deleteJobType(data)" pTooltip="Delete"
                                        tooltipPosition="top"><i class="pi pi-trash"></i></span>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <!-- <p-accordionTab header="{{'Configuration.User.Phone_Type' | transloco}}">
          <p-table [value]="phonetype" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
              <tr>
                <th class="p-col-10">{{'Configuration.User.Name' | transloco}}</th>
                <th class="p-col-2">{{'Configuration.User.Action' | transloco}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
              <tr [pReorderableRow]="index">

                <td class="p-col-10">{{data.name}}</td>
                <td class="p-col-2 action">
                  <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[8])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                  <span class="btnBars p-mr-0" (click)="delPhoneType(index)" pTooltip="Delete"
                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-accordionTab> -->
            <!-- <p-accordionTab header="Relationship Status">
          <p-table [value]="relations" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
              <tr>
                <th class="p-col-10">Name</th>
                <th class="p-col-2">Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
              <tr [pReorderableRow]="index">
                <td class="p-col-10">{{data.name}}</td>
                <td class="p-col-2 action">
                  <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[3])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                  <span class="btnBars p-mr-0" (click)="delRelationshipStatus(data)" pTooltip="Delete"
                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-accordionTab> -->
            <!-- <p-accordionTab header="{{'Configuration.User.Social_Profile_Type' | transloco}}">
          <p-table [value]="socials" [scrollable]="true" scrollHeight="180px">
            <ng-template pTemplate="header">
              <tr>
                <th class="p-col-10">{{'Configuration.User.Name' | transloco}}</th>
                <th class="p-col-2">{{'Configuration.User.Action' | transloco}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-index="rowIndex">
              <tr [pReorderableRow]="index" style="cursor: move;">
                <td class="p-col-10">{{data.name}}</td>
                <td class="p-col-2 action">
                  <span class="btnBars p-mr-0" (click)="showEditContactData(data,
                    contactDataTypes[10])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                      pi-pencil"></i></span>
                  <span class="btnBars p-mr-0" (click)="delSocialType(index)" pTooltip="Delete"
                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-accordionTab> -->
        </p-accordion>
    </p-tabPanel>

    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu #configmenuUser id="config_menu_user" [model]="configMenuUserItems" [popup]="true"
                appendTo="body"></p-menu>
            <span class="btnBars p-mr-0" (click)="configmenuUser.toggle($event)">
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>

<p-dialog header="{{ 'Configuration.User.Template' | transloco }} - {{
        'Configuration.User.User' | transloco
    }}" [(visible)]="displayEditUserTemplate" [modal]="true" [responsive]="true" [style]="{ width: '60em' }">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-md-5 p-pr-0">
                <h6 class="p-pl-4">
                    {{ "Configuration.User.Label_Name" | transloco }}
                </h6>
                <p-table [value]="availableUserLabels_info">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="header">
                                <h5>
                                    {{
                                    "Configuration.User.User_Information"
                                    | transloco
                                    }}
                                </h5>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-label>
                        <tr>
                            <td>
                                {{ label.labelname }}
                                <span style="color: red" *ngIf="label.movable == false">*</span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-7 p-pl-0">
                <div class="p-grid">
                    <h6 class="p-col p-mb-2 p-pl-4">
                        {{ "Configuration.User.Edit_Label_Name" | transloco }}
                    </h6>
                    <h6 class="p-col-fixed p-mb-2" style="width: 100px">
                        {{ "Configuration.User.Show_Hide" | transloco }}
                    </h6>
                </div>
                <p-table [value]="selectedUserLabels_info" dataKey="id" class="editable">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="header"></th>
                            <th style="width: 100px" class="p-text-center header">
                                <p-checkbox (click)="selectedUserRow1(u1.checked)" #u1 ngDefaultControl
                                    [(ngModel)]="selectedUserCheck1" binary="true"></p-checkbox>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-label>
                        <tr>
                            <td pEditableColumn>
                                <input pInputText type="text" [(ngModel)]="label.labelname" />
                            </td>
                            <td class="p-text-center">
                                <p-checkbox [disabled]="!label.movable" [value]="label" ngDefaultControl
                                    [(ngModel)]="label.checked" binary="true"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12 p-md-5 p-pr-0">
                <p-table [value]="availableUserLabels_address">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="header">
                                <h5>
                                    {{
                                    "Configuration.User.Address_Information"
                                    | transloco
                                    }}
                                </h5>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-label>
                        <tr>
                            <td>
                                {{ label.labelname }}
                                <span style="color: red" *ngIf="
                                        label.isMovable == false &&
                                        label.width !== 2
                                    ">*</span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-7 p-pl-0">
                <p-table [value]="selectedUserLabels_address" dataKey="id" class="editable">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="header"></th>
                            <th style="width: 100px" class="p-text-center header">
                                <p-checkbox (click)="selectedUserRow2(u2.checked)" #u2 ngDefaultControl
                                    [(ngModel)]="selectedUserCheck2" binary="true"></p-checkbox>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-label>
                        <tr>
                            <td pEditableColumn>
                                <input pInputText type="text" [(ngModel)]="label.labelname" />
                            </td>
                            <td class="p-text-center">
                                <p-checkbox [disabled]="!label.movable" [value]="label" ngDefaultControl
                                    [(ngModel)]="label.checked" binary="true"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12 p-md-5 p-pr-0">
                <p-table [value]="availableUserLabels_other_info">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="header">
                                <h5>
                                    {{
                                    "Configuration.User.Other_Information"
                                    | transloco
                                    }}
                                </h5>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-label>
                        <tr>
                            <td>
                                {{ label.labelname }}
                                <span style="color: red" *ngIf="label.isMovable == false">*</span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-7 p-pl-0">
                <p-table [value]="selectedUserLabels_other_info" dataKey="id" class="editable">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="header"></th>
                            <th style="width: 100px" class="p-text-center header">
                                <p-checkbox (click)="selectedUserRow3(u3.checked)" #u3 ngDefaultControl
                                    [(ngModel)]="selectedUserCheck3" binary="true"></p-checkbox>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-label>
                        <tr>
                            <td pEditableColumn>
                                <input pInputText type="text" [(ngModel)]="label.labelname" />
                            </td>
                            <td class="p-text-center">
                                <p-checkbox name="display" [disabled]="!label.movable" value="val"
                                    [(ngModel)]="label.checked" binary="true"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton label="{{ 'Configuration.User.Save' | transloco }}"
            (click)="updateUserTemplate()"></button>
        <button type="button" pButton (click)="displayEditUserTemplate = false"
            label="{{ 'Configuration.User.Cancel' | transloco }}" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<p-dialog header="{{ addEditUserHeader }}" [modal]="true" *ngIf="displayAddUser" [(visible)]="displayAddUser"
    [style]="{ width: '60vw' }" [baseZIndex]="10000">

    <app-subscription-limit-message
        *ngIf="subscriptionLimitReached"
        [subscriptionLimit]="subscriptionLimit"
        [moduleName]="'Users'">
    </app-subscription-limit-message>

    <form *ngIf="!subscriptionLimitReached" (ngSubmit)="saveUser()" #addEditUserForm="ngForm" autocomplete="off">
        <div class="header">
            <h5>
                {{ "Configuration.User.User_Information" | transloco }}
                <p-inputSwitch class="header-switch" name="isActive" [(ngModel)]="tempUser.statusId"></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-grid" *ngIf="
                    selectedUserLabels_info &&
                    ((selectedUserLabels_info[2]
                        ? selectedUserLabels_info[2].checked == true
                        : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[3]
                            ? selectedUserLabels_info[3].checked == true
                            : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[1]
                            ? selectedUserLabels_info[1].checked == true
                            : null))
                ">
                <div class="p-col-12 p-lg-6" *ngIf="
                        selectedUserLabels_info[1]
                            ? selectedUserLabels_info[1].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[1]
                        ? selectedUserLabels_info[1].labelname
                        : null
                        }}
                        <span style="color: red">*</span>
                    </label>
                    <input type="text" name="firstName" #userFirstName="ngModel" [disabled]="isDisabledUserEdit"
                        pInputText [(ngModel)]="tempUser.firstName" required />
                    <small *ngIf="
                            userFirstName.errors?.required &&
                            (userFormSubmitted || userFirstName.touched)
                        " class="p-invalid">{{
                        "Configuration.User.First_Name_is_required"
                        | transloco
                        }}</small>
                </div>
                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[2]
                            ? selectedUserLabels_info[2].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[2]
                        ? selectedUserLabels_info[2].labelname
                        : null
                        }}
                    </label>
                    <input type="text" name="middleName" [disabled]="isDisabledUserEdit" pInputText
                        [(ngModel)]="tempUser.middleName" />
                </div>
                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[3]
                            ? selectedUserLabels_info[3].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[3]
                        ? selectedUserLabels_info[3].labelname
                        : null
                        }}
                    </label>
                    <input type="text" name="lastName" [disabled]="isDisabledUserEdit" pInputText
                        [(ngModel)]="tempUser.lastName" />
                </div>
            </div>

            <div class="p-grid" *ngIf="
                    selectedUserLabels_info &&
                    ((selectedUserLabels_info[0]
                        ? selectedUserLabels_info[0].checked == true
                        : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[4]
                            ? selectedUserLabels_info[4].checked == true
                            : null))
                ">
                <div class="p-col-12 p-lg-6" *ngIf="
                        selectedUserLabels_info[0]
                            ? selectedUserLabels_info[0].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[0]
                        ? selectedUserLabels_info[0].labelname
                        : null
                        }}
                        <span style="color: red">*</span>
                    </label>
                    <input type="email" name="email" #userEmail="ngModel" [disabled]="isDisabledUserEdit" pInputText
                        [(ngModel)]="tempUser.emailId" required
                        pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" email />
                    <small *ngIf="
                            userEmail.errors?.pattern &&
                            (userFormSubmitted || userEmail.touched)
                        " class="p-invalid">{{
                        "Configuration.User.Enter_valid_Email" | transloco
                        }}</small>
                    <small *ngIf="
                            userEmail.errors?.required &&
                            (userFormSubmitted || userEmail.touched)
                        " class="p-invalid">{{
                        "Configuration.User.Email_is_required" | transloco
                        }}</small>
                </div>
                <div class="p-col-12 p-lg-6" *ngIf="
                        selectedUserLabels_info[4]
                            ? selectedUserLabels_info[4].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[4]
                        ? selectedUserLabels_info[4].labelname
                        : null
                        }}
                    </label>
                    <input type="text" name="phone" [disabled]="isDisabledUserEdit" pInputText
                        [(ngModel)]="tempUser.userPhones[0].phone.number" />
                </div>
            </div>

            <div class="p-grid" *ngIf="
                    (selectedUserLabels_info && selectedUserLabels_info[7]
                        ? selectedUserLabels_info[7].checked == true
                        : null) ||
                    (selectedUserLabels_info && selectedUserLabels_info[8]
                        ? selectedUserLabels_info[8].checked == true
                        : null) ||
                    (selectedUserLabels_info && selectedUserLabels_info[9]
                        ? selectedUserLabels_info[9].checked == true
                        : null)
                ">
                <div class="p-col-6 p-lg-6" *ngIf="
                        selectedUserLabels_info[8]
                            ? selectedUserLabels_info[8].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[8]
                        ? selectedUserLabels_info[8].labelname
                        : null
                        }}<span style="color: red">*</span></label>
                    <p-treeSelect [options]="allRoleHierarchy" #userRole="ngModel" [(ngModel)]="selectedRoleHierarchy"
                        appendTo="body" placeholder="{{
                            'Configuration.User.Select_Role' | transloco
                        }}" [disabled]="isDisabledUserEdit" required [ngModelOptions]="{ standalone: true }">
                    </p-treeSelect>
                    <small *ngIf="
                            userRole.errors?.required &&
                            (userFormSubmitted || userRole.touched)
                        " class="p-invalid">{{ "Configuration.User.Role_is_required" | transloco }}
                    </small>
                </div>
                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[7]
                            ? selectedUserLabels_info[7].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[7]
                        ? selectedUserLabels_info[7].labelname
                        : null
                        }}</label>
                    <p-dropdown [options]="genders" [disabled]="isDisabledUserEdit" [(ngModel)]="selectedGender"
                        placeholder="{{
                            'Configuration.User.Select_Gender' | transloco
                        }}" optionLabel="name" [ngModelOptions]="{ standalone: true }">
                    </p-dropdown>
                </div>
                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[9]
                            ? selectedUserLabels_info[9].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[9]
                        ? selectedUserLabels_info[9].labelname
                        : null
                        }}<span style="color: red">*</span></label>
                    <p-dropdown #useJobType="ngModel" [options]="jobTypes" [disabled]="isDisabledUserEdit"
                        [(ngModel)]="selectedJobType" required placeholder="Select a job type" optionLabel="name"
                        [ngModelOptions]="{ standalone: true }" appendTo="body">
                    </p-dropdown>
                    <small *ngIf="
                            useJobType.errors?.required &&
                            (userFormSubmitted || useJobType.touched)
                        " class="p-invalid">User
                        {{
                        selectedUserLabels_info[7]
                        ? selectedUserLabels_info[7].labelname
                        : null
                        }}
                        is required
                    </small>
                </div>
            </div>

            <div class="p-grid" *ngIf="
                    showAddMore &&
                    ((selectedUserLabels_info[5]
                        ? selectedUserLabels_info[5].checked == true
                        : null) ||
                        (selectedUserLabels_info[6]
                            ? selectedUserLabels_info[6].checked == true
                            : null) ||
                        (selectedUserLabels_info[7]
                            ? selectedUserLabels_info[7].checked == true
                            : null))
                ">
                <div class="p-col-12 p-lg-6" *ngIf="
                        selectedUserLabels_info[5]
                            ? selectedUserLabels_info[5].checked == true
                            : null || selectedUserLabels_info[6]
                            ? selectedUserLabels_info[6].checked == true
                            : null
                    ">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-12" *ngIf="
                                selectedUserLabels_info[5]
                                    ? selectedUserLabels_info[5].checked == true
                                    : null
                            ">
                            <label>{{
                                selectedUserLabels_info[5]
                                ? selectedUserLabels_info[5].labelname
                                : null
                                }}
                            </label>
                            <input type="text" name="selectedSocialProfile" pInputText [disabled]="isDisabledUserEdit"
                                [(ngModel)]="
                                    tempUser.userSocialProfiles[0].socialProfile
                                        .name
                                " />
                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-lg-6" *ngIf="
                        showAddMore && selectedUserLabels_info[6]
                            ? selectedUserLabels_info[6].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[6]
                        ? selectedUserLabels_info[6].labelname
                        : null
                        }}</label>
                    <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                        [showUploadButton]="false" [showCancelButton]="false" multiple="false" accept="image/*"
                        (onSelect)="uploadProfilePic($event.files)" [disabled]="isDisabledUserEdit">
                        <ng-template pTemplate="file"></ng-template>
                        <ng-template pTemplate="content">
                            <ng-container *ngIf="tempUser.profileImage">
                                <ng-container *ngIf="
                                        tempUser.profileImage.statusId === 1 &&
                                        tempUser.profileImage.content
                                    ">
                                    <div class="p-fileupload-row">
                                        <div>
                                            <ng-container *ngIf="
                                                    tempUser.profileImage &&
                                                        tempUser.profileImage
                                                            .content &&
                                                        tempUser.profileImage.content.startsWith(
                                                            'data'
                                                        );
                                                    else localImage
                                                ">
                                                <img src="{{
                                                        tempUser.profileImage
                                                            .content
                                                    }}" width="100" alt="Profile Image" />
                                            </ng-container>
                                            <ng-template #localImage>
                                                <img [src]="
                                                        tempUser.profileImage &&
                                                        tempUser.profileImage
                                                            .location
                                                    " width="100" alt="card" />
                                            </ng-template>
                                        </div>
                                        <div>
                                            {{ tempUser.profileImage.name }}
                                        </div>
                                        <div>
                                            {{
                                            (
                                            tempUser.profileImage
                                            .sizeInBytes / 1024
                                            ).toFixed(2) + " KB"
                                            }}
                                        </div>
                                        <div>
                                            <button icon="pi pi-times" pButton (click)="removeProfileImage(i)"
                                                type="button" icon="pi pi-times"></button>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </div>

            <div class="p-field p-formgrid p-grid" *ngIf="
                    showAddMore &&
                    ((selectedUserLabels_info && selectedUserLabels_info[7]
                        ? selectedUserLabels_info[7].checked == true
                        : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[8]
                            ? selectedUserLabels_info[8].checked == true
                            : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[9]
                            ? selectedUserLabels_info[9].checked == true
                            : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[10]
                            ? selectedUserLabels_info[10].checked == true
                            : null))
                ">
                <!-- <div class="p-col-6 p-lg-3"
                    *ngIf="selectedUserLabels_info[10] ? selectedUserLabels_info[10].checked == true : null">
                    <label>{{selectedUserLabels_info[10] ? selectedUserLabels_info[10].labelname : null}} <span
                            *ngIf="!selectedUserLabels_info[10].movable" style="color: red;">*</span></label>
                    <p-dropdown [options]="allProfile" [disabled]="isDisabledUserEdit" [(ngModel)]="selectedProfile"
                        placeholder="Select a profile" optionLabel="name" appendTo="body" #userProfile="ngModel"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="isProfileSelected = (selectedProfile !== null)" required>
                    </p-dropdown>
                    <small *ngIf="userProfile.errors?.required && (userFormSubmitted ||
          userProfile.touched)" class="p-invalid">Profile is required
                    </small>
                </div> -->
            </div>

            <div class="p-grid" *ngIf="
                    showAddMore &&
                    ((selectedUserLabels_info && selectedUserLabels_info[11]
                        ? selectedUserLabels_info[11].checked == true
                        : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[12]
                            ? selectedUserLabels_info[12].checked == true
                            : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[13]
                            ? selectedUserLabels_info[13].checked == true
                            : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[14]
                            ? selectedUserLabels_info[14].checked == true
                            : null))
                ">
                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[11]
                            ? selectedUserLabels_info[11].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[11]
                        ? selectedUserLabels_info[11].labelname
                        : null
                        }}</label>
                    <p-dropdown [options]="departments" [disabled]="isDisabledUserEdit" [(ngModel)]="selectedDepartment"
                        placeholder="{{
                            'Configuration.User.Select_Department' | transloco
                        }}" optionLabel="name" name="department" [ngModelOptions]="{ standalone: true }">
                    </p-dropdown>
                </div>

                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[12]
                            ? selectedUserLabels_info[12].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[12]
                        ? selectedUserLabels_info[12].labelname
                        : null
                        }}</label>
                    <p-calendar [maxDate]="maxDate" name="dob" [yearRange]="getYearRange()" [monthNavigator]="true"
                        [yearNavigator]="true" styleClass="w-100" [readonlyInput]="true" [showIcon]="true"
                        [disabled]="isDisabledUserEdit" [(ngModel)]="tempUser.dateOfBirth" appendTo="body">
                    </p-calendar>
                </div>

                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[13]
                            ? selectedUserLabels_info[13].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[13]
                        ? selectedUserLabels_info[13].labelname
                        : null
                        }}</label>
                    <p-multiSelect [options]="languages" [disabled]="isDisabledUserEdit" [(ngModel)]="selectedLanguages"
                        optionLabel="name" placeholder="{{
                            'Configuration.User.Select_Languages' | transloco
                        }}" #selectedLanguageref="ngModel" [ngModelOptions]="{ standalone: true }">
                    </p-multiSelect>
                </div>

                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[14]
                            ? selectedUserLabels_info[14].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[14]
                        ? selectedUserLabels_info[14].labelname
                        : null
                        }}</label>
                    <p-calendar [maxDate]="maxDate" name="joiningDate" styleClass="w-100" [readonlyInput]="true"
                        [showIcon]="true" [disabled]="isDisabledUserEdit" [(ngModel)]="tempUser.userDetail.joiningDate"
                        appendTo="body">
                    </p-calendar>
                </div>
            </div>

            <div class="p-grid" *ngIf="
                    showAddMore &&
                    ((selectedUserLabels_info && selectedUserLabels_info[15]
                        ? selectedUserLabels_info[15].checked == true
                        : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[16]
                            ? selectedUserLabels_info[16].checked == true
                            : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[17]
                            ? selectedUserLabels_info[17].checked == true
                            : null) ||
                        (selectedUserLabels_info && selectedUserLabels_info[18]
                            ? selectedUserLabels_info[18].checked == true
                            : null))
                ">
                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[15]
                            ? selectedUserLabels_info[15].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[15]
                        ? selectedUserLabels_info[15].labelname
                        : null
                        }}</label>
                    <p-dropdown [options]="maritals" [disabled]="isDisabledUserEdit"
                        [(ngModel)]="selectedMaritialStatus" placeholder="{{
                            'Configuration.User.Select_Maritial_Status'
                                | transloco
                        }}" optionLabel="name" [ngModelOptions]="{ standalone: true }" appendTo="body">
                    </p-dropdown>
                </div>

                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[16]
                            ? selectedUserLabels_info[16].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[16]
                        ? selectedUserLabels_info[16].labelname
                        : null
                        }}</label>
                    <p-dropdown [options]="degrees" [disabled]="isDisabledUserEdit" [(ngModel)]="selectedDegree"
                        appendTo="body" placeholder="{{
                            'Configuration.User.Select_Degree' | transloco
                        }}" optionLabel="name" [ngModelOptions]="{ standalone: true }">
                    </p-dropdown>
                </div>

                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[17]
                            ? selectedUserLabels_info[17].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[17]
                        ? selectedUserLabels_info[17].labelname
                        : null
                        }}</label>
                    <p-dropdown [options]="incomes" [disabled]="isDisabledUserEdit" [(ngModel)]="selectedAnnulIncome"
                        placeholder="{{
                            'Configuration.User.Select_Annual_Income'
                                | transloco
                        }}" optionLabel="name" [ngModelOptions]="{ standalone: true }" appendTo="body">
                    </p-dropdown>
                </div>

                <div class="p-col-6 p-lg-3" *ngIf="
                        selectedUserLabels_info[18]
                            ? selectedUserLabels_info[18].checked == true
                            : null
                    ">
                    <label>{{
                        selectedUserLabels_info[18]
                        ? selectedUserLabels_info[18].labelname
                        : null
                        }}</label>
                    <p-dropdown [options]="studyFields" [disabled]="isDisabledUserEdit"
                        [(ngModel)]="selectedFieldOfStudy" placeholder="{{
                            'Configuration.User.Select_Field_Of_Study'
                                | transloco
                        }}" optionLabel="name" [ngModelOptions]="{ standalone: true }" appendTo="body">
                    </p-dropdown>
                </div>
            </div>

            <div class="p-grid" *ngIf="showAddMore && (selectedUserLabels_info?.[19]?.checked || selectedUserLabels_info?.[20]?.checked)">
                <div class="p-col-6 p-lg-3" *ngIf="selectedUserLabels_info?.[19]?.checked">
                    <label>{{
                        selectedUserLabels_info[19]
                        ? selectedUserLabels_info[19].labelname
                        : null
                        }}</label>
                    <input type="text" name="seniority" [disabled]="isDisabledUserEdit" pInputText
                        [(ngModel)]="tempUser.seniority" />
                </div>

                <div class="p-col-6 p-lg-3" *ngIf="selectedUserLabels_info?.[20]?.checked">
                    <label>{{
                        selectedUserLabels_info[20]
                        ? selectedUserLabels_info[20].labelname
                        : null
                        }} <span style="color: red">*</span></label>
                        <p-dropdown [options]="workingLocation" [filter]="true" filterBy="name" [disabled]="isDisabledUserEdit"
                        placeholder="select location" [(ngModel)]="selectedWorkingLocation" optionLabel="name"
                        [ngModelOptions]="{ standalone: true }" appendTo="body" required>
                        </p-dropdown>
                </div>
            </div>

            <div class="p-text-right" *ngIf="
                    showUserformaddresfields ||
                    showUserformOtherfields ||
                    selectedUserLabelsFieldsCount > 5
                ">
                <button type="button" style="margin: 10px 0" pButton (click)="showAddMore = !showAddMore" label="{{
                        showAddMore
                            ? userTranslate.ShowLess
                            : userTranslate.ShowMore
                    }}" class="p-button-secondary"></button>
            </div>
        </div>

        <p-tabView class="no-padding">
            <p-tabPanel header="Home Address" *ngIf="showUserformaddresfields">
                <div class="card">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-12">
                            <div class="p-grid">
                                <div class="p-col-12 p-lg-12" *ngIf="
                                        selectedUserLabels_address[0]
                                            ? selectedUserLabels_address[0]
                                                  .checked == true
                                            : null
                                    ">
                                    <label>{{
                                        selectedUserLabels_address[0]
                                        ? selectedUserLabels_address[0]
                                        .labelname
                                        : null
                                        }}</label>
                                    <!-- <input type="text" name="mstreat_address1" [disabled]="isDisabledUserEdit" pInputText [(ngModel)]="tempUser.mainAddress.streetAddress1"> -->
                                    <lion-gm-place-autocomplete
                                    [disabled]="isDisabledUserEdit"
                                    [formattedAddress]="addressInput" (onRemoveAddress)="
                                            onRemoveAddressLocation(
                                                $event,
                                                'main'
                                            )
                                        " (onAddressChange)="
                                            onAddressChanged($event, 'main')
                                        " (onSettingAddrress)="
                                            onAddressBlur($event, 'main')
                                        ">

                                    </lion-gm-place-autocomplete>

                                </div>
                                <div class="p-col-12 p-lg-12" *ngIf="
                                        selectedUserLabels_address[1]
                                            ? selectedUserLabels_address[1]
                                                  .checked == true
                                            : null
                                    ">
                                    <label>{{
                                        selectedUserLabels_address[1]
                                        ? selectedUserLabels_address[1]
                                        .labelname
                                        : null
                                        }}</label>
                                    <input type="text" name="mstreat_address2" [disabled]="isDisabledUserEdit"
                                        pInputText [(ngModel)]="
                                            tempUser.mainAddress.streetAddress2
                                        " />
                                </div>
                            </div>

                            <div class="p-grid">
                                <div class="p-col-12 p-lg-6" *ngIf="
                                        selectedUserLabels_address[2]
                                            ? selectedUserLabels_address[2]
                                                  .checked == true
                                            : null
                                    ">
                                    <label>{{
                                        selectedUserLabels_address[2]
                                        ? selectedUserLabels_address[2]
                                        .labelname
                                        : null
                                        }}</label>
                                    <p-dropdown [options]="countries" [filter]="true" [disabled]="isDisabledUserEdit"
                                        [(ngModel)]="selectedMCountry" placeholder="{{
                                            'Configuration.User.Select_Country'
                                                | transloco
                                        }}" (onChange)="loadCountryStates('main')" optionLabel="name"
                                        [ngModelOptions]="{ standalone: true }" appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="
                                        selectedUserLabels_address[3]
                                            ? selectedUserLabels_address[3]
                                                  .checked == true
                                            : null
                                    ">
                                    <label>{{
                                        selectedUserLabels_address[3]
                                        ? selectedUserLabels_address[3]
                                        .labelname
                                        : null
                                        }}</label>

                                    <p-dropdown [options]="allStates" [filter]="true" [disabled]="isDisabledUserEdit"
                                        [(ngModel)]="selectedMState" placeholder="{{
                                            'Configuration.User.Select_State'
                                                | transloco
                                        }}" (onChange)="loadCountryCities('main')" optionLabel="name"
                                        [ngModelOptions]="{ standalone: true }" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-grid">
                                <div class="p-col-12 p-lg-6" *ngIf="
                                        selectedUserLabels_address[4]
                                            ? selectedUserLabels_address[4]
                                                  .checked == true
                                            : null
                                    ">
                                    <label>{{
                                        selectedUserLabels_address[4]
                                        ? selectedUserLabels_address[4]
                                        .labelname
                                        : null
                                        }}</label>

                                    <p-dropdown [options]="allCities" [filter]="true" [disabled]="isDisabledUserEdit"
                                        [(ngModel)]="selectedMCity" placeholder="{{
                                            'Configuration.User.Select_City'
                                                | transloco
                                        }}" optionLabel="name" [ngModelOptions]="{ standalone: true }" appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="
                                        selectedUserLabels_address[5]
                                            ? selectedUserLabels_address[5]
                                                  .checked == true
                                            : null
                                    ">
                                    <label>{{
                                        selectedUserLabels_address[5]
                                        ? selectedUserLabels_address[5]
                                        .labelname
                                        : null
                                        }}</label>
                                    <input type="text" name="selectedMZipcode" [disabled]="isDisabledUserEdit"
                                        pInputText [(ngModel)]="
                                            tempUser.mainAddress.zipCode
                                        " />
                                </div>
                            </div>
                        </div>
                        <!-- postal address -->
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Permission">
                <p-table [value]="permissionsTB" dataKey="id" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Channel Name</th>
                            <th>Profile Name</th>
                            <th>Is Active</th>
                            <th>Is Default</th>
                            <th>Action</th>
                            <th style="width: 2rem" class="action">
                                <p-button icon="pi pi-plus" (click)="addPermission()"></p-button>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-permission let-i="rowIndex">
                        <tr>
                            <td>{{ permission.channelName }}</td>
                            <td>{{ permission.userProfileName }}</td>
                            <td>
                                <span *ngIf="permission.isActive">Yes</span>
                                <span *ngIf="!permission.isActive">No</span>
                            </td>
                            <td>
                                <p-radioButton [value]="true" name="radioButtonGroup" [(ngModel)]="permission.isDefault"
                                    (onClick)="
                                        makeDefaultPermission(permission, i)
                                    " [ngModelOptions]="{ standalone: true }"
                                    [disabled]="!permission.isActive"></p-radioButton>
                                {{ permission.isDefault ? "Yes" : "No" }}
                            </td>
                            <td class="action">
                                <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"
                                    (click)="editPermission(permission, i)">
                                    <i class="pi pi-pencil"></i>
                                </span>
                                <span *ngIf="!permission.isDefault" class="btnBars p-mr-0" pTooltip="Delete"
                                    tooltipPosition="top" (click)="deletePermission(permission, i)">
                                    <i class="pi pi-trash"></i>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
            <p-tabPanel header="Other" *ngIf="showUserformOtherfields">
                <div class="card">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-6" *ngIf="
                                selectedUserLabels_other_info[0]
                                    ? selectedUserLabels_other_info[0]
                                          .checked == true
                                    : null
                            ">
                            <label>{{
                                selectedUserLabels_other_info[0]
                                ? selectedUserLabels_other_info[0].labelname
                                : null
                                }}</label>
                            <p-dropdown [options]="timeZoneList" [disabled]="isDisabledUserEdit"
                                [(ngModel)]="selectedTimeZone" placeholder="{{
                                    'Configuration.User.Select_Timezone'
                                        | transloco
                                }}" appendTo="body" optionLabel="name" name="timeZone"
                                [ngModelOptions]="{ standalone: true }">
                            </p-dropdown>
                        </div>
                        <div class="p-col-6 p-lg-3" *ngIf="
                                selectedUserLabels_other_info[1]
                                    ? selectedUserLabels_other_info[1]
                                          .checked == true
                                    : null
                            ">
                            <label>{{
                                selectedUserLabels_other_info[1]
                                ? selectedUserLabels_other_info[1].labelname
                                : null
                                }}</label>
                            <p-calendar [maxDate]="maxDate" name="trackingStartTime" styleClass="w-100"
                                [readonlyInput]="true" [showTime]="true" [showIcon]="true"
                                [disabled]="isDisabledUserEdit" appendTo="body" [(ngModel)]="
                                    tempUser.userDetail.trackingStartTime
                                " appendTo="body">
                            </p-calendar>
                        </div>
                        <div class="p-col-6 p-lg-3" *ngIf="
                                selectedUserLabels_other_info[2]
                                    ? selectedUserLabels_other_info[2]
                                          .checked == true
                                    : null
                            ">
                            <label>{{
                                selectedUserLabels_other_info[2]
                                ? selectedUserLabels_other_info[2].labelname
                                : null
                                }}</label>
                            <p-calendar [maxDate]="maxDate" name="trackingEndTime" styleClass="w-100"
                                [readonlyInput]="true" [showTime]="true" [showIcon]="true"
                                [disabled]="isDisabledUserEdit" appendTo="body" [(ngModel)]="
                                    tempUser.userDetail.trackingEndTime
                                " appendTo="body">
                            </p-calendar>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayAddUser = false; clearUserForm()" label="{{ 'Configuration.User.Cancel' | transloco }}" class="p-button-secondary"></button>
        <button *ngIf="!subscriptionLimitReached" type="submit" (click)="addEditUserForm?.ngSubmit?.emit()" pButton [disabled]="
                isDisabledUserEdit ||
                !addEditUserForm?.valid ||
                permissionsTB?.length < 1 ||
                !selectedRoleHierarchy ||
                !selectedJobType" label="{{ 'Configuration.User.Save' | transloco }}"></button>
    </ng-template>
</p-dialog>

<p-dialog header="{{ permissionHeader }}" [(visible)]="displayAddEditPermission" [modal]="true"
    [style]="{ width: '55vw' }">
    <div class="header">
        <h5>
            Permission Information
            <p-inputSwitch class="header-switch" [(ngModel)]="permissionActiveInactiveToggle"
                [disabled]="isDisabledUserEdit || tempPermission?.isDefault"></p-inputSwitch>
        </h5>
    </div>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <label>Channel Name</label>
                <p-dropdown [options]="channelsN" placeholder="Choose Channel" [disabled]="isDisabledUserEdit"
                    [(ngModel)]="selectedChannelN" optionLabel="name" appendTo="body" #userChannel="ngModel"
                    [ngModelOptions]="{ standalone: true }" required>
                </p-dropdown>
            </div>
            <div class="p-col-12 p-md-6">
                <label>Profile Name</label>
                <p-dropdown [options]="allProfile" [disabled]="isDisabledUserEdit" [(ngModel)]="selectedProfile"
                    placeholder="Select a profile" optionLabel="name" appendTo="body" #userProfile="ngModel"
                    [ngModelOptions]="{ standalone: true }" required>
                </p-dropdown>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayAddEditPermission = false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton (click)="savePermission()" class="p-button-success" label="Save"></button>
    </p-footer>
</p-dialog>

<p-dialog header="User Template Labels Swap" [(visible)]="displaySwapUserLabels" [modal]="true"
    [style]="{ width: '60vw' }">
    <div class="header">
        <h5>User Information</h5>
    </div>
    <div class="card" cdkDropListGroup>
        <div class="p-grid" cdkDropList [cdkDropListData]="selectedUserLabels_info"
            (cdkDropListDropped)="dropUserTemplateField($event)">
            <ng-container *ngFor="let s of selectedUserLabels_info">
                <div [ngClass]="{ 'p-col-12 p-lg-3': s.width == '3' }" [cdkDragDisabled]="s.movable == false" cdkDrag
                    *ngIf="s.showForDrag == true">
                    <label>{{ s.labelname }}
                        <span style="color: red" *ngIf="s.movable == false">*</span>
                    </label>
                    <input type="text" pInputText disabled />
                </div>
            </ng-container>
        </div>
    </div>
    <div class="header">
        <h5>Address Information</h5>
    </div>
    <div class="card" cdkDropListGroup>
        <div class="p-grid" cdkDropList [cdkDropListData]="selectedUserLabels_address"
            (cdkDropListDropped)="dropUserTemplateField($event)">
            <ng-container *ngFor="let s of selectedUserLabels_address">
                <div [ngClass]="{ 'p-col-12 p-lg-3': s.width == '3' }" [cdkDragDisabled]="s.movable == false" cdkDrag
                    *ngIf="s.showForDrag == true">
                    <label>{{ s.labelname }}
                        <span style="color: red" *ngIf="s.movable == false">*</span>
                    </label>
                    <input type="text" pInputText disabled />
                </div>
            </ng-container>
        </div>
    </div>
    <div class="header">
        <h5>Other Information</h5>
    </div>
    <div class="card" cdkDropListGroup>
        <div class="p-grid" cdkDropList [cdkDropListData]="selectedUserLabels_other_info"
            (cdkDropListDropped)="dropUserTemplateField($event)">
            <ng-container *ngFor="let s of selectedUserLabels_other_info">
                <div [ngClass]="{ 'p-col-12 p-lg-3': s.width == '3' }" [cdkDragDisabled]="s.movable == false" cdkDrag
                    *ngIf="s.showForDrag == true">
                    <label>{{ s.labelname }}
                        <span style="color: red" *ngIf="s.movable == false">*</span>
                    </label>
                    <input type="text" pInputText disabled />
                </div>
            </ng-container>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displaySwapUserLabels = false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveUserTemplateLabelsSwap()" class="p-button-success"
            label="Save"></button>
    </p-footer>
</p-dialog>

<p-dialog header="{{ addEditUserGroupHeader }}" [modal]="true" [(visible)]="displayAddUserGroup"
    [style]="{ width: '50vw' }" [baseZIndex]="10000" (onHide)="userGroupFormSubmitted = false">
    <form #userGroupForm="ngForm" (ngSubmit)="saveUserGroup()">
        <div class="p-grid">
            <div class="p-col-6">
                <label for="name">{{ "Configuration.User.Group_Name" | transloco }}
                    <span style="color: red">*</span></label>
                <input type="text" pInputText [(ngModel)]="tempUserGroup.group.name" name="name"
                    (change)="trimGroupName()" [disabled]="isDisabledUserGroupEdit" #groupName="ngModel" required />
                <small *ngIf="
                        groupName.errors?.required &&
                        (userGroupFormSubmitted ||
                            groupName.dirty ||
                            groupName.touched)
                    " class="p-invalid">{{
                    "Configuration.User.Group_Name_is_required" | transloco
                    }}</small>
            </div>
            <div class="p-col-6">
                <label>{{ "Configuration.User.User" | transloco }}
                    <span style="color: red">*</span>
                </label>
                <p-multiSelect [options]="allUsers" [(ngModel)]="tempUserGroup.users" name="users" dataKey="id"
                    optionLabel="name" placeholder="{{
                        'Configuration.User.Select_Users' | transloco
                    }}" #users="ngModel" appendTo="body" required [disabled]="isDisabledUserGroupEdit">
                </p-multiSelect>
                <small *ngIf="
                        users.errors?.required &&
                        (userGroupFormSubmitted || users.touched)
                    " class="p-invalid">{{ "Configuration.User.Select_Users" | transloco }}</small>
            </div>

            <div class="p-col-6">
                <label>{{ "Configuration.User.Group_Owners" | transloco }}
                    <span style="color: red">*</span></label>
                <p-multiSelect [options]="tempUserGroup.users" [(ngModel)]="tempUserGroup.groupOwners"
                    name="groupOwners" dataKey="id" optionLabel="name" placeholder="{{
                        'Configuration.User.Select_Group_Owner' | transloco
                    }}" appendTo="body" [disabled]="isDisabledUserGroupEdit" #groupOwner="ngModel" required>
                </p-multiSelect>
                <small *ngIf="
                        groupOwner.errors?.required &&
                        (userGroupFormSubmitted || groupOwner.touched)
                    " class="p-invalid">{{
                    "Configuration.User.Select_Group_Owner" | transloco
                    }}</small>
            </div>
            <div class="p-col-6">
                <label>{{
                    "Configuration.User.Parent_Group" | transloco
                    }}</label>
                <p-dropdown appendTo="body" [options]="allUserGroup" name="parentGroup"
                    [(ngModel)]="tempUserGroup.group.parentGroup" optionLabel="group.name" dataKey="group.id"
                    placeholder="{{
                        'Configuration.User.Select_Parent_Group' | transloco
                    }}" [showClear]="true" [disabled]="isDisabledUserGroupEdit"
                    [ngModelOptions]="{ standalone: true }">
                </p-dropdown>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayAddUserGroup = false" label="{{ 'Configuration.User.Cancel' | transloco }}"
            class="p-button-secondary"></button>
        <button type="submit" pButton (click)="userGroupForm.ngSubmit.emit()" class="p-button-success"
            [disabled]="isDisabledUserGroupEdit || userGroupForm.form.invalid"
            label="{{ 'Configuration.User.Save' | transloco }}"></button>
    </ng-template>
</p-dialog>

<p-dialog header="{{ 'Configuration.User.Org_Chart' | transloco }}" [modal]="true" [(visible)]="displayOpenOrgChart"
    [style]="{ width: '60vw' }">
    <div class="card">
        <p-organizationChart [value]="orgData" selectionMode="single" [(selection)]="selectedNode"
            (onNodeSelect)="onNodeSelect($event)" styleClass="company">
            <ng-template let-node pTemplate="person">
                <div class="node-header p-corner-top">{{ node.label }}</div>
                <div class="node-content">
                    <div>{{ node.data.name }}</div>
                </div>
            </ng-template>
            <ng-template let-node pTemplate="department">
                {{ node.label }}
            </ng-template>
        </p-organizationChart>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayOpenOrgChart = false" label="{{ 'Configuration.User.Cancel' | transloco }}"
            class="p-button-secondary"></button>
    </ng-template>
</p-dialog>

<!-- contacts -->
<p-dialog header="{{ addEditContactHeader }}" [modal]="true" [(visible)]="displayAddContactData"
    [style]="{ width: '50vw' }" [baseZIndex]="10000" (onHide)="closeAddEditFieldDataPopup()">
    <div class="p-grid">
        <div class="p-col-12" *ngIf="
                addEditContactHeader == 'Add Field Data' ||
                addEditContactHeader == 'Ajouter des données de champ' ||
                addEditContactHeader == '添加字段数据'
            ">
            <label for="type">{{ "Configuration.User.Fields_Type" | transloco
                }}<span style="color: red">*</span></label>
            <p-dropdown [options]="
                    currentModule == 'user' ? userDataTypes : contactDataTypes
                " [(ngModel)]="selectedContactDataType" optionLabel="name" placeholder="{{
                    'Configuration.User.Select_Field_Type' | transloco
                }}" [ngModelOptions]="{ standalone: true }" appendTo="body" (onChange)="getContactDataType()"
                #userDataType="ngModel" required></p-dropdown>
            <small *ngIf="
                    (contactDataFormSubmitted &&
                        userDataType.invalid &&
                        (userDataType.touched || userDataType.dirty)) ||
                    fieldTypeSelectionError
                " class="p-invalid">
                Select Field type to add
            </small>
        </div>
        <div class="p-col-12" *ngIf="
                addEditContactHeader == 'Edit Field Data' ||
                addEditContactHeader == '编辑字段数据' ||
                addEditContactHeader == 'Modifier les données de champ'
            ">
            <h5 class="p-mb-0">
                {{ "Configuration.User.Fields_Name" | transloco }} --
                {{ contactDataTypes[contactTypeId].name }}
            </h5>
        </div>
        <div class="p-col-12">
            <label for="name">{{ "Configuration.User.Name" | transloco }}
                <span style="color: red">*</span></label>
            <input type="text" pInputText [ngModel]="contactDataTemp?.name" #dataName="ngModel" required [ngClass]="{
                    'p-invalid':
                        (dataName.invalid &&
                            (dataName.touched || dataName.dirty)) ||
                        invalidData == true
                }" (ngModelChange)="getChangeContact($event)" (ngModelChange)="contactDataTemp.name = $event" />
            <small *ngIf="
                    (contactDataFormSubmitted &&
                        dataName.invalid &&
                        (dataName.touched || dataName.dirty)) ||
                    fieldTypeSelectionError
                " class="p-invalid">
                {{ "Configuration.User.Name_Is_required" | transloco }}
            </small>
            <small *ngIf="invalidData == true" class="p-invalid">
                {{ "Configuration.User.Name_Exists" | transloco }}
            </small>
        </div>
        <div class="p-col-12">
            <label for="name">{{
                "Configuration.User.Description" | transloco
                }}</label>
            <input type="text" pInputText style="width: 100%" [ngModel]="contactDataTemp?.description"
                (ngModelChange)="contactDataTemp.description = $event" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeAddEditFieldDataPopup()" label="{{ 'Configuration.User.Cancel' | transloco }}"
            class="p-button-secondary"></button>
        <button pButton (click)="saveContactDataAdd()" label="{{ 'Configuration.User.Save' | transloco }}"></button>
    </ng-template>
</p-dialog>

<!-- Transfer Job Type Modal -->
<p-dialog header="Transfer Job Type" [modal]="true" [(visible)]="displayTransferJobTypeModal"
    [style]="{ width: '50vw' }" [baseZIndex]="10000" (onHide)="closeTransferJobTypeModal()">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p>
                    Job Type to be deleted:
                    <b>{{ jobTypeForTransfer?.name }}</b>
                </p>
            </div>
            <div class="p-col-12">
                <label for="type">Move users to Job Type<span style="color: red">*</span></label>
                <p-dropdown [options]="filteredJobTypes" [(ngModel)]="selectedJobTypeForTransfer" optionLabel="name"
                    placeholder="Select a job type" [ngModelOptions]="{ standalone: true }" appendTo="body"
                    #userDataType="ngModel" required (onChange)="onChangeJobType($event)"></p-dropdown>
                <small *ngIf="
                        (userDataType.invalid &&
                            (userDataType.touched || userDataType.dirty)) ||
                        jobTypeSelectionError
                    " class="p-invalid">
                    Select a Job Type
                </small>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeTransferJobTypeModal()" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="transferAndDeleteJobType(false, true)" label="Transfer and Delete"></button>
    </ng-template>
</p-dialog>

<!-- permission -->
<p-dialog header="Edit Permission" [modal]="true" [(visible)]="displayPermission" [style]="{ width: '60vw' }">
    <div class="card">
        <p-tabView [(activeIndex)]="index">
            <p-tabPanel header="{{
                    'Configuration.User.Assign_Permission' | transloco
                }} ({{ 'Configuration.User.User' | transloco }} -
      {{ selectedUser?.name }})">
                <form (ngSubmit)="assignUserPermission()" #userPermissionForm="ngForm">
                    <p-table [value]="userPermisions" class="assignPermission">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    {{
                                    "Configuration.User.Module_CRM"
                                    | transloco
                                    }}
                                </th>
                                <th>
                                    <span>{{
                                        "Configuration.User.View" | transloco
                                        }}</span>
                                    <p-checkbox class="heaerCheckbox" [(ngModel)]="allViewPermissions"
                                        (onChange)="setAllChildPermissions(0)" binary="true"
                                        [ngModelOptions]="{ standalone: true }">
                                    </p-checkbox>
                                </th>
                                <th>
                                    <span>{{
                                        "Configuration.User.Create" | transloco
                                        }}</span>
                                    <p-checkbox class="heaerCheckbox" [(ngModel)]="allCreatePermissions"
                                        (onChange)="setAllChildPermissions(1)" binary="true"
                                        [ngModelOptions]="{ standalone: true }">
                                    </p-checkbox>
                                </th>
                                <th>
                                    <span>{{
                                        "Configuration.User.Edit" | transloco
                                        }}</span>
                                    <p-checkbox class="heaerCheckbox" [(ngModel)]="allEditPermissions"
                                        (onChange)="setAllChildPermissions(2)" binary="true"
                                        [ngModelOptions]="{ standalone: true }">
                                    </p-checkbox>
                                </th>
                                <th>
                                    <span>{{
                                        "Configuration.User.Delete" | transloco
                                        }}</span>
                                    <p-checkbox class="heaerCheckbox" [(ngModel)]="allDeletePermissions"
                                        (onChange)="setAllChildPermissions(3)" binary="true"
                                        [ngModelOptions]="{ standalone: true }">
                                    </p-checkbox>
                                </th>
                                <th>
                                    <span>{{
                                        "Configuration.User.Export" | transloco
                                        }}</span>
                                    <p-checkbox class="heaerCheckbox" [(ngModel)]="allExportPermissions"
                                        (onChange)="setAllChildPermissions(4)" binary="true"
                                        [ngModelOptions]="{ standalone: true }">
                                    </p-checkbox>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-userPermissionObj let-i="rowIndex">
                            <tr>
                                <td>{{ userPermissionObj.objectName }}</td>
                                <ng-container *ngFor="
                                        let permission of userPermissionObj.permissions
                                    ">
                                    <td *ngIf="permission.permissionId < 6">
                                        <p-checkbox class="permissionCheckbox" (onChange)="
                                                permissionChanged(
                                                    permission,
                                                    userPermissionObj.objectId
                                                )
                                            " [(ngModel)]="permission.checked" binary="true" [ngModelOptions]="{
                                                standalone: true
                                            }">
                                            {{ permission.permissionId }}
                                        </p-checkbox>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-template>
                    </p-table>
                </form>
            </p-tabPanel>
            <p-tabPanel header="{{ 'Configuration.User.Reports' | transloco }} ({{
                    'Configuration.User.User' | transloco
                }} - {{ selectedUser?.name }})">
                <form (ngSubmit)="assignReportUserPermission()" #userPermissionReportForm="ngForm">
                    <p-treeTable [value]="reportPermissionData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    {{
                                    "Configuration.User.Report_Module"
                                    | transloco
                                    }}
                                </th>
                                <th style="width: 80px">
                                    {{ "Configuration.User.View" | transloco }}
                                </th>
                                <th style="width: 80px">
                                    {{
                                    "Configuration.User.Export" | transloco
                                    }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttRow]="rowNode">
                                <td>
                                    <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                    {{ rowData.name }}
                                </td>
                                <td>
                                    <p-checkbox [(ngModel)]="rowData.view" (onChange)="
                                            CheckAllChild(rowData, 'view')
                                        " binary="true" [ngModelOptions]="{ standalone: true }"></p-checkbox>
                                </td>
                                <td>
                                    <p-checkbox [(ngModel)]="rowData.export" (onChange)="
                                            CheckAllChild(rowData, 'export')
                                        " binary="true" [ngModelOptions]="{ standalone: true }"></p-checkbox>
                                </td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                </form>
            </p-tabPanel>
        </p-tabView>
    </div>
    <ng-template pTemplate="footer">
        <ng-container *ngIf="index == 0">
            <button pButton (click)="displayPermission = false" label="{{ 'Configuration.User.Cancel' | transloco }}"
                class="p-button-secondary"></button>
            <button type="submit" (click)="userPermissionForm.ngSubmit.emit()" pButton
                [disabled]="updatedUserPermissions.length == 0"
                label="{{ 'Configuration.User.Save' | transloco }}"></button>
        </ng-container>
        <ng-container *ngIf="index == 1">
            <button pButton (click)="displayPermission = false" label="{{ 'Configuration.User.Cancel' | transloco }}"
                class="p-button-secondary"></button>
            <button type="submit" class="pull-right" (click)="userPermissionReportForm.ngSubmit.emit()" pButton
                [disabled]="isDisabledUserEdit" label="{{ 'Configuration.User.Save' | transloco }}"></button>
        </ng-container>
    </ng-template>
</p-dialog>

<app-shared-associated-users [displayAssociatedUsersModal]="displayAssociatedUsersModal"
    [associatedUsersFrom]="subModuleName" [associatedUsersSubModuleId]="jobTypeIdForSelectedAssociatedUser"
    [associatedUsers]="associatedUsers" (closeAssociatedUserModalOutputEvent)="
        closeAssociatedUserModalOutputEvent()
    " (completedAddNewUser)="completedAddNewUser()">
</app-shared-associated-users>
